import React, { useEffect } from 'react'

export const ImageModal = ({
  selectedImage,
  setImage,
}: {
  selectedImage: string
  setImage: (value: string) => void
}) => {
  useEffect(() => {
    const handleScroll = () => {
      setImage('')
    }
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      {selectedImage && (
        <div className="light-box" onClick={() => setImage('')}>
          <div
            className="light-box-bg"
            onClick={() => {
              setImage('')
            }}
          ></div>
          <div className="light-box-container">
            <img className="light-box-image" src={selectedImage} />
          </div>
        </div>
      )}
    </>
  )
}
